import { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const OTPVerify = () => {

    const { login } = useAuth();

    const [otp, setOtp] = useState('');
    const [error, setError] = useState(false);

    const handleOTPSubmit = async (e) => {
        e.preventDefault();
        setError(false);

        const email = localStorage.getItem('temp_email');

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/verify-otp/`, {
                email,
                otp,
            });

            const { access_token, refresh_token, user_details } = response.data;

            localStorage.removeItem('temp_email');
            localStorage.removeItem('temp_username');
            localStorage.removeItem('temp_password');

            // Save in context or cookies
            // Call your login() method
            login({ access_token, refresh_token, user_details });
            window.location.href = '/'; // redirect to home
        } catch (error) {
            console.error('OTP error:', error);
            setError(true);
        }
    };

    return (
        <form onSubmit={handleOTPSubmit}>
            <h3>Enter OTP sent to your email</h3>
            {error && <div className="alert alert-danger">Invalid OTP</div>}
            <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter 6-digit OTP"
                required
                maxLength={6}
            />
            <button type="submit">Verify OTP</button>
        </form>
    );
};

export default OTPVerify;
